import { HttpErrorResponse } from '@angular/common/http';

export class LockedError extends Error {
    httpStatus = 423;

    constructor(res: HttpErrorResponse, message?: string) {
        super(message ? message : res.statusText);
        Object.setPrototypeOf(this, LockedError.prototype);
    }
}
